import type { UnverifiedAssetOriginKind } from '@terra/shared-contracts-assets';

export const UNVERIFIED_ASSET_ORIGIN_LABEL_KEYS = {
  SOURCE_CODE: 'originSourceCode',
  OPENAPI: 'originOpenApi',
  JAVASCRIPT: 'originJavascript',
  CRAWLING: 'originCrawling',
  DIRECTORY_SCAN: 'originDirectoryScan',
  INTEGRATION: 'originIntegration',
  MANUAL: 'originManual',
  OTHER: 'originOther',
} as const satisfies Record<UnverifiedAssetOriginKind, `origin${string}`>;

export const resolveUnverifiedAssetOriginLabelKey = ({
  originKind,
}: {
  originKind: UnverifiedAssetOriginKind;
}): (typeof UNVERIFIED_ASSET_ORIGIN_LABEL_KEYS)[UnverifiedAssetOriginKind] =>
  UNVERIFIED_ASSET_ORIGIN_LABEL_KEYS[originKind] ??
  UNVERIFIED_ASSET_ORIGIN_LABEL_KEYS.OTHER;
